import FundoAdm from '../../assets/images/fundoAdm'
import { AdmStyle } from './style'

export function Administrativo() {
  return (
    <AdmStyle>
      <FundoAdm />
    </AdmStyle>
  )
}
